import * as React from "react";
import "./EditAnnotationDialog.component.css";
import { GenericDialog } from "../generic-dialog/GenericDialog.component";
import { useEffect, useRef, useState } from "react";
import { busServiceMain } from "../../../modules/bus";
import { STTAnnotationAnswerMessage, STTEditAnnotationInDialogRequestMessage } from "../../../messages/stt/STTMessages";
import { useTranslation } from "react-i18next";
const busConnection = busServiceMain.connection("EditAnnotationDialog");
export function EditAnnotationDialog() {
    const [isVisible, setIsVisible] = useState(false);
    const [editedText, setEditedText] = useState("");
    const originalText = useRef("");
    const lastAskId = useRef("");
    const { t } = useTranslation();
    useEffect(() => {
        busConnection.subscribeForAskRequest(STTEditAnnotationInDialogRequestMessage, (msg, askId) => {
            setIsVisible((prev) => {
                if (prev)
                    throw new Error("EditAnnotationDialog is already visible");
                return true;
            });
            lastAskId.current = askId;
            originalText.current = msg.currentAnnotation;
            setEditedText(msg.currentAnnotation);
        });
    }, []);
    const reject = () => {
        busConnection.answer(lastAskId.current, new STTAnnotationAnswerMessage(originalText.current));
        setIsVisible(false);
    };
    const confirm = () => {
        busConnection.answer(lastAskId.current, new STTAnnotationAnswerMessage(editedText));
        setIsVisible(false);
    };
    const getAdditionalButtons = () => [
        {
            text: t("sessionview:annotation-dialog-button-reset-text", "Reset"),
            onClick: () => {
                setEditedText(originalText.current);
            },
            disabled: editedText === originalText.current,
            tooltip: t("sessionview:annotation-dialog-button-reset-text-tooltip", "Reset to original text"),
            tooltipDisabled: t("sessionview:annotation-dialog-button-reset-tooltip-disabled", "There are no changes to reset")
        },
        {
            text: t("sessionview:annotation-dialog-button-clear-text", "Clear"),
            onClick: () => {
                setEditedText("");
            },
            disabled: editedText === "",
            tooltip: t("sessionview:annotation-dialog-button-clear-text-tooltip", "Remove all text"),
            tooltipDisabled: t("sessionview:annotation-dialog-button-clear-text-tooltip-disabled", "There is no text to remove")
        }
    ];
    return (React.createElement(React.Fragment, null, isVisible && (React.createElement(GenericDialog, { title: t("sessionview:annotation-dialog-title", "Edit Annotation"), confirmText: t("sessionview:annotation-dialog-button-save", "Save"), cancelText: t("sessionview:annotation-dialog-button-cancel", "Cancel"), onCancel: reject, onConfirm: confirm, confirmAllowed: editedText !== originalText.current, confirmTooltipDisabled: t("sessionview:annotation-dialog-button-save-tooltip-disabled", "There are no changes"), buttonsToTheLeft: getAdditionalButtons(), width: "narrow" },
        React.createElement("textarea", { className: "edit-annotation-dialog-textarea", rows: 7, value: editedText, onChange: (e) => {
                setEditedText(e.target.value);
            } })))));
}
